import { render, staticRenderFns } from "./PersistPrivateCategoryView.vue?vue&type=template&id=33e9cac4"
import script from "./PersistPrivateCategoryView.vue?vue&type=script&lang=ts"
export * from "./PersistPrivateCategoryView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports